import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import usefull from './useful';
import useful from './useful';
import gsap from "gsap"


// Menu 
class Menu {
    constructor() {
        const header = document.querySelector('.header');
        if (header) {
            this.redirectToHome(header)
            this.animate()
        }
    }
    animate() {
        var tl = gsap.timeline()
        tl.set('.header__logo, .header__nav li', {
            opacity: 0,
            y: 10
        })
            .to('.header__logo, .header__nav li', {
                opacity: 1,
                stagger: .3,
                delay: .3,
                y: 0
            })
    }


    redirectToHome(root) {
        const logo = root.querySelector(`[class *="__logo"]`)
        const redirection = logo.dataset.href || "/"
        logo.onclick = () => {
            window.location.href = logo.dataset.href
        }
    }
}

export class MenuMobile extends Menu {
    constructor() {
        super();

        if (document.querySelector(".header-mobile")) {
            // var
            this.headerMobile = document.querySelector(".header-mobile");
            this.navLinks = document.querySelectorAll(".header-mobile__nav li a")
            // init
            this.init()
            this.redirectToHome(this.headerMobile)
            // events
            this.navLinks.forEach(el => el.addEventListener('click',
                () => this.closeMobile()
            ), true)
            // clean
            return this.navLinks.forEach(el => el.removeEventListener('click',
                () => this.closeMobile()
            ), true)
        }
    }

    init() {
        this.mobileView = false;
        this.buttonClose = document.querySelector(".header-mobile [data-menu-close]")
        this.buttonOpen = document.querySelector(".header-mobile [data-menu-open]")

        // set
        this.setMobileView()

        //
        this.buttonOpen.onclick = () => {
            this.openMobile();
        }

        this.buttonClose.onclick = () => {
            this.closeMobile();
        }

        // bouton contact dans menu mobile
        const buttonContact = document.querySelector(".header-mobile [data-popin-button]");

        if(buttonContact) buttonContact.onclick = () => {
            this.closeMobile()
        }
    }

    setMobileView() {
        this.mobileView = usefull.isTablet();

        if (this.mobileView) {
            window.addEventListener("resize", () => {
                this.isMobileView = useful.isTablet();
                if (usefull.isTablet()) {
                    this.closeMobile()
                }
            })

        }
    }

    openMobile() {
        this.headerMobile.setAttribute("data-menu-open", "true")
        this.animateOpen();
        disableBodyScroll(this.headerMobile)
    }

    closeMobile() {
        this.headerMobile.removeAttribute("data-menu-open", "false")
        enableBodyScroll(this.headerMobile)

    }

    // animation à l'ouverture
    animateOpen() {

        const tl = gsap.timeline();

        tl.from(".header-mobile__nav li", {
            autoAlpha: 0,
            y: 10,
            delay: 0.2,
            stagger: 0.1
        })
            .from(".header-mobile__social a", {
                autoAlpha: 0,
                y: 10,
                stagger: 0.1,
                delay: -0.5,
            })
            .from(".header-mobile__contact", {
                autoAlpha: 0,
                y: 10,
                delay: -0.3,
                stagger: 0.1
            })


    }
}

export class MenuSticky extends Menu {
    constructor() {
        super();
        // var
        const header = document.querySelector(".header");

        if (header) {
            this.headerRef = header;
            this.offset = this.headerRef.scrollHeight;
            this.lastScroll = 0;
            this.options = {
                reverseMode: false
            }

            // init
            this.createDOMSticky();
            this.redirectToHome(this.headerDesktopSticky)
            // events
            window.addEventListener("scroll", () => this.setMenuDesktopSticky())
        }
    }

    createDOMSticky() {
        const header = document.createElement("header")
        header.classList.add("header")
        header.classList.add("header-sticky")
        header.classList.add("g-container")
        header.innerHTML = this.headerRef.innerHTML
        header.setAttribute("data-menu-sticky", false)

        document.querySelector(".header-group").appendChild(header)

        this.headerDesktopSticky = document.querySelector("header[data-menu-sticky]")

    }

    // rend Sticky le menu desktop
    setMenuDesktopSticky() {
        this.setDeltaScroll();

        if (window.scrollY >= 200) {
            if(this.options.reverseMode){
                this.getDeltaScroll() >= 0 ? this.hideSticky() : this.showSticky();
            }
            else{
                this.showSticky()
            }
        } else {
            this.hideSticky()
        }
    }

    setDeltaScroll() {
        let positionY = window.scrollY;
        this.delta = 0;
        this.lastScroll <= positionY ? this.delta = 1 : this.delta = -1;
        this.lastScroll = positionY;
    }

    getDeltaScroll() {
        return this.delta
    }

    hideSticky() {
        this.headerDesktopSticky.setAttribute(["data-menu-sticky"], "false")
    }

    showSticky() {
        this.headerDesktopSticky.setAttribute(["data-menu-sticky"], "true")
    }
    destroySticky() {
        this.headerDesktopSticky.remove();
    }

}